export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6154.c647b2da.jpg";